import { AxiosInstance } from 'axios';

import {
  EphemeralStorageAPIApiFactory,
  ImpactReportAPIApiFactory,
  PersistentVolumeAPIApiFactory,
  PersistentVolumePolicyAPIApiFactory,
  StorageActionsAPIApiFactory,
  StorageMetricsAPIApiFactory,
} from '@cast/openapi-stop';

import { AXIOS_CONFIGURATION } from '../constants';

export const StopApiAdapter = (client: AxiosInstance) => {
  const ephemeralStorageApi = EphemeralStorageAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const persistentVolumeApi = PersistentVolumeAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const persistentVolumePolicyApi = PersistentVolumePolicyAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const storageActionsApi = StorageActionsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const storageMetricsApi = StorageMetricsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const impactReportApi = ImpactReportAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    evaluateEphemeralStorageState:
      ephemeralStorageApi.ephemeralStorageAPIEvaluateState,
    getNodeDiskRecommendation:
      ephemeralStorageApi.ephemeralStorageAPIGetNodeDiskRecommendation,
    getInstallationScript:
      ephemeralStorageApi.ephemeralStorageAPIInstallationScript,
    listNodeDiskRecommendations:
      ephemeralStorageApi.ephemeralStorageAPIListNodeDiskRecommendations,

    getPersistentVolumeDetails:
      persistentVolumeApi.persistentVolumeAPIGetPersistentVolumeDetails,
    getPersistentVolumesAutoscalingConfig:
      persistentVolumeApi.persistentVolumeAPIGetPersistentVolumesAutoscalingConfig,
    getPersistentVolumesCapabilities:
      persistentVolumeApi.persistentVolumeAPIGetPersistentVolumesCapabilities,
    getPersistentVolumesSummary:
      persistentVolumeApi.persistentVolumeAPIGetPersistentVolumesSummary,
    listPersistentVolumes:
      persistentVolumeApi.persistentVolumeAPIListPersistentVolumes,
    searchPersistentVolumeFilterValues:
      persistentVolumeApi.persistentVolumeAPISearchPersistentVolumeFilterValues,

    createPvPolicy:
      persistentVolumePolicyApi.persistentVolumePolicyAPICreatePolicy,
    deletePvPolicy:
      persistentVolumePolicyApi.persistentVolumePolicyAPIDeletePolicy,
    getPvPolicy: persistentVolumePolicyApi.persistentVolumePolicyAPIGetPolicy,
    listPvPolicies:
      persistentVolumePolicyApi.persistentVolumePolicyAPIListPolicies,
    setPvPoliciesOrder:
      persistentVolumePolicyApi.persistentVolumePolicyAPISetPoliciesOrder,
    syncPvPolicies:
      persistentVolumePolicyApi.persistentVolumePolicyAPISyncPolicies,
    updatePvPolicy:
      persistentVolumePolicyApi.persistentVolumePolicyAPIUpdatePolicy,

    listStorageActions: storageActionsApi.storageActionsAPIListStorageActions,

    getNodeStorageMetrics:
      storageMetricsApi.storageMetricsAPIGetNodeStorageMetrics,
    getNodeStorageSummary:
      storageMetricsApi.storageMetricsAPIGetNodeStorageSummary,
    getClusterStorageSummary:
      storageMetricsApi.storageMetricsAPIGetClusterStorageSummary,
    getCloudVolumeMetrics:
      storageMetricsApi.storageMetricsAPIGetCloudVolumeMetrics,

    getImpactReport: impactReportApi.impactReportAPIGetImpactReport,
  };
};
